import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createMeta, createRowActions } from "@msuite/ui/table";
import { CalculationTypeTag } from "@msuite/ui/tag";
import { formatNumber } from "@msuite/utils/numbers";
import type { PartnerTimelineInvoiceTrackingItem } from "@msuite/utils/types";
import { PartnerTimelineInvoiceTrackingInvoiceNumber } from "./partner-timeline-invoice-tracking-invoice-number";
import { PartnerTimelineInvoiceTrackingReport } from "./partner-timeline-invoice-tracking-report";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<PartnerTimelineInvoiceTrackingItem>();

export const columns = [
	columnHelper.accessor("invoiceNumber", {
		id: "invoiceNumber",
		header: localized("invoices.number"),
		cell: (cell) => <PartnerTimelineInvoiceTrackingInvoiceNumber item={cell.row.original} />,
	}),
	columnHelper.accessor("workspaceId", {
		id: "workspaceId",
		header: localized("organization.workspace"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("reportNumber", {
		id: "reportNumber",
		header: localized("partners.reports.report_number"),
		cell: (cell) => <PartnerTimelineInvoiceTrackingReport item={cell.row.original} />,
	}),
	columnHelper.accessor("projectNumber", {
		id: "projectNumber",
		header: localized("projects.fields.project_number"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("projectName", {
		id: "projectName",
		header: localized("projects.fields.project_name"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("calculationType", {
		id: "calculationType",
		header: localized("general.type"),
		cell: (cell) => <CalculationTypeTag type={cell.getValue()} />,
	}),
	columnHelper.accessor((row) => formatNumber(row.total, "currency"), {
		id: "total",
		header: localized("invoices.sum_net"),
		cell: (cell) => cell.getValue(),
		meta: createMeta({
			isNumeric: true,
		}),
	}),
	columnHelper.accessor((row) => formatNumber(row.total * 1.19, "currency"), {
		id: "total-gross",
		header: localized("invoices.sum_gross"),
		cell: (cell) => cell.getValue(),
		meta: createMeta({
			isNumeric: true,
		}),
	}),
	createRowActions(RowActions),
];
